import { render } from "./Collectiondetail.vue?vue&type=template&id=20aa549d&scoped=true"
import script from "./Collectiondetail.vue?vue&type=script&lang=js"
export * from "./Collectiondetail.vue?vue&type=script&lang=js"

import "./Collectiondetail.vue?vue&type=style&index=0&id=20aa549d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-20aa549d"

export default script